"use client";

import { c as _c } from "react/compiler-runtime";
import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";
import type { ProposalFormValues } from "@/lib/proposal";
import { ProposalChoiceCard } from "./proposal-choice-card";
import { proposalChoiceGroupClassName } from "./proposal-form-constants";
type ProposalStepBudgetProps = {
  budgetOptions: readonly string[];
  control: Control<ProposalFormValues>;
};
export function ProposalStepBudget(t0) {
  const $ = _c(5);
  const {
    budgetOptions,
    control
  } = t0;
  let t1;
  if ($[0] !== budgetOptions) {
    t1 = t2 => {
      const {
        field,
        fieldState
      } = t2;
      return <><div className={`${proposalChoiceGroupClassName} grid! grid-cols-2!`}>{budgetOptions.map(option => <ProposalChoiceCard active={field.value === option} key={option} onClick={() => field.onChange(option)}><span>{option}</span></ProposalChoiceCard>)}</div>{fieldState.error && <p className="text-sm text-red-300" data-proposal-animate={true}>{fieldState.error.message}</p>}</>;
    };
    $[0] = budgetOptions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== control || $[3] !== t1) {
    t2 = <Controller control={control} name="budget" render={t1} />;
    $[2] = control;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}